if (!customElements.get('wish-list-button')) {
  class WishListButton extends HTMLElement {
    constructor() {
      super();
      this.meta = meta;
      this.state = {
        opacityAdded: '1',
        opacityRemoved: '0.4',
        isAdded: false,
      };
      this.is_current_page_btn = (this.classList.contains("wishListButton")) ? true:false;

      this.notification = this.querySelector('wish-list-notification');
      this.setupEventForButton();
    }

    /**
     * @returns {string[]}
     */
    static get observedAttributes() {
      return ['product-id', 'product-variant-id'];
    }

    // noinspection JSUnusedGlobalSymbols
    connectedCallback() {
      if (!this.rendered) {
        this.init();
      }
    }

    // noinspection JSUnusedGlobalSymbols
    attributeChangedCallback() {
      this.init();
    }

    setupData() {
      this.data = {
        productId: parseInt(this.getAttribute('product-id')),
        variantId: parseInt(this.getAttribute('product-variant-id')),
        productUrl: this.getAttribute('product-url')
      };
    }

    init() {
      this.setupData();
      this.themeLoaded((swat) => {
        this.swat = swat;
        this.swatData = SwymProductVariants[this.data.variantId];
        this.guestPopup = !window.isCustomer ? document.querySelector('swym-guest-popup') : false;

        if (!this.swatData) {
          this.swatData = {
            empi: this.data.productId,
            epi: this.data.variantId,
            du: this.data.productUrl
          };
        }

        this.render();
      });

      this.rendered = true;
    }

    /**
     * @param addedCallBack
     * @param removedCallBack
     */
    wishListLoader(addedCallBack, removedCallBack) {
      this.swat.fetch((list) => {
        let isInWishList = list.find((item) => {
          return item.empi === this.data.productId && item.epi === this.data.variantId;
        })

        if (isInWishList) {
          addedCallBack();
        } else {
          removedCallBack();
        }
      });
    }

    /**
     * @param callback
     */
    themeLoaded(callback) {
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }

      window.SwymCallbacks.push((swat) => {
        callback(swat);
      });
    }

    render() {
      this.wishListLoader(() => {
        this.setWishListAdded();
      }, () => {
        this.setWishListRemoved();
      });
    }

    setupEventForButton() {
      this.addEventListener('click', () => {

        if(!window.isCustomer && this.guestPopup) {
          this.guestPopup._show();
          this.guestPopup.returnToUrlInput.value = location.href;
          return;
        }

        if(this.classList.contains('swym-wishlist-disable')) return;
        //詳細ページのwishlistボタンからの追加か判定
        if(this.is_current_page_btn){
          this.swatData.cprops = {
            "isProductDetail": true
          }
        }
        if (this.state.isAdded) {
          this.swat.removeFromWishList(this.swatData, () => {
            this.setWishListRemoved();
            this.newEventForUpdateStatus();
          });
        } else {
          this.swat.addToWishList(this.swatData, () => {
            this.setWishListAdded();
            this.showNotificationAdded();
            this.newEventForUpdateStatus();
          });
        }

        this.reCheck();
      });
      // Apply only product detail
      if(this.is_current_page_btn)this.setupEventForProductDetail();
    }

    setupEventForProductDetail() {
      if (this.meta.page.resourceType === 'product') {
        if(this.meta.product.variants.length >= 2){
          document.querySelector('[name="id"]').addEventListener('change', (e) => {
            let variantId = e.target.value;
            let selectColor;
            let selectSize;
            let variantData = document.querySelector('#variantData');
            let variants = ISSEYMIYAKE['JSONParse'](variantData?.textContent);
            document.dispatchEvent(new CustomEvent('swym:option_changed', { detail: { variantId: variantId }}));

            variantId ? this.classList.remove('swym-wishlist-disable') : this.classList.add('swym-wishlist-disable');

            this.setAttribute('product-variant-id', variantId);

            if (variantId != "") {
              this.classList.remove("disable");
            }

            if (this.meta.product && this.meta.product.variants) {
              if (!variantId) {
                var productOptionsInputs = document.querySelectorAll('._color .product_options_input');

                let waitForInternalProcessing = new Promise((resolve) => {
                  productOptionsInputs.forEach(function (input) {
                    input.addEventListener('click', function (i) {
                      selectColor = i.target.value;
                      const variant = variants.filter(variant => variant.option1 == selectColor);
                      selectSize = variant[0].option2;
                      input.dispatchEvent(new Event('change'));
                      resolve();
                    });
                  });
                });

                waitForInternalProcessing.then(() => {
                  this.notification.hide();
                  this.notification.modifyContent({
                    color: selectColor,
                    size: selectSize,
                    image: this.swatData?.iu ? this.swatData.iu : ''
                  });
                }).catch((error) => {
                  console.error(error);
                });
              } else {
                const variant = variants.filter(variant => variant.id == Number(variantId))

                this.notification.hide();
                this.notification.modifyContent({
                  color: variant[0].option1,
                  size: variant[0].option2,
                  image: this.swatData?.iu ? this.swatData.iu : ''
                });
              }
            }
          });
        }
      }
    }

    /**
     * Re-check all wishListButton
     * In case there is more than 1 button on the same page, the state will be synchronized.
     */
    reCheck() {
      let wishListOther = document.querySelectorAll(`[product-variant-id="${this.data.variantId}"]`);
      if (wishListOther) {
        wishListOther.forEach((button) => {
          if (button !== this) {
            setTimeout(() => {
              button.setAttribute('product-variant-id', this.data.variantId.toString());
            }, 2000);
          }
        });
      }
    }

    showNotificationAdded() {
      if (this.notification) {
        this.notification.show();
      }
    }

    setWishListAdded() {
      this.state.isAdded = true;
      this.classList.add("on")
      this.querySelector('button').setAttribute('aria-pressed', true)
    }

    setWishListRemoved() {
      this.state.isAdded = false;
      this.classList.remove("on")
      this.querySelector('button').setAttribute('aria-pressed', false)
    }

    newEventForUpdateStatus() {
      this.dispatchEvent(new CustomEvent("changeStatus", {bubbles: true}));
    }
  }

  customElements.define('wish-list-button', WishListButton);
}
